import AnswersList from './AnswersList'

export default AnswersList
